export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_04.a67d047d.png";